module.exports = __webpack_public_path__ + "img/187.0e94232b.jpg";